export function formatGp(amount: number | string): string {
  return `${amount} GP`;
}
